$(document).ready(function () {

// footer menu collapsible

if (window.innerWidth <= 820) {
$(document).on('click','.menu--wrapper .menu-titles', function(e){
  e.preventDefault();
  var $_this = $(this),
  $wrapper = $_this.closest('.menu--wrapper'),
  $menu_content = $_this.next('ul.footer-block__detail-content');


  $('.menu--wrapper').not($wrapper).removeClass('active-menu');
  $('.menu--wrapper .menu-titles').not($_this).removeClass('active');
  $('ul.footer-block__detail-content').not($menu_content).removeClass('active');

  // $menu_content.toggle();
  $menu_content.toggleClass('active');
  $_this.toggleClass('active');
  $wrapper.toggleClass('active-menu');
});
}


   setTimeout(function () {
$(".doubly-wrapper .doubly-nice-select .current").css("color", "white");
   }, 8000);
  $('.all_testimon').wrapAll('<div class="testmon"></div>')
  // codecopy
  $(document).on("click", ".copy_text", function () {
    var copyText = document.getElementById("dis_code");
    copyText.select();
    navigator.clipboard.writeText(copyText.value);

    var originalCode = $(".copy_text").text();

    $(".copy_text").text("Code copied!");

    setTimeout(function () {
      $(".copy_text").text(originalCode);
    }, 2000);
  });

  // card product swatch chng
  $(document).on("click", ".label-color", function () {
    var $el = $(this).attr("imgsrc");
    if ($el !== undefined) {
      $(this).parents(".grid__item").find(".cng-img").attr("src", $el);
      $(this).parents(".grid__item").find(".cng-img").attr("srcset", $el);
    }
  });

  $(".main-img").slick({
    adaptiveHeight: true,
    arrows: true,
    asNavFor: ".thumb-img",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".thumb-img").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    asNavFor: ".main-img",
    focusOnSelect: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // product media



  function filterSliders(var_place) {
  
    var $mainSlider = $(".main-img");
    var $thumbSlider = $(".thumb-img");

    if (
      $mainSlider.hasClass("slick-initialized") &&
      $thumbSlider.hasClass("slick-initialized")
    ) {
    
      try {
        $mainSlider.slick("slickUnfilter");
        $thumbSlider.slick("slickUnfilter");

        $mainSlider.slick("slickFilter", "." + var_place);
        $thumbSlider.slick("slickFilter", "." + var_place);
      } catch (error) {
        console.error("Error applying filter:", error);
      }
    } else {
      console.log("Sliders not initialized or missing classes.");
    }
  }

  // Initial filter based on default checked value
  var default_varia_val = $(".old_swatches input[type=radio]:checked").attr(
    "data-color-val"
  );
  setTimeout(function (params) {
    filterSliders(default_varia_val);
  }, 1);

  $(".thumb-img, .main-img").on("init", function (event, slick) {
    var $el = $(event.target),
      $wrap = $el.closest(".product__media-wrapper"),
      $current = $el.find(".slick-current.slick-active"),
      index = $current.data("slick-index"),
      $main = $wrap.find(".main-img"),
      $thumb = $wrap.find(".thumb-img");
     $thumb.find(".thumbnail").hide();
    $thumb.find(`[data-slick-index="${index}"] .thumbnail`).show();
    console.log(
      $thumb.find(".thumbnail"),
      $thumb.find(`[data-slick-index="${index}"] .thumbnail`)
    );
  });

  $(document).on("click", ".heart-wish", function () {
    if (WishListHero_SDK) {
      WishListHero_SDK.OpenWishList();
    }
  });

  // gallery popup

  $(document).on("click", ".image__popup", function () {
    var $el = $(this),
      src = $el.attr("data-src");
    $el.addClass("active");
    $(".modal--content--inner img").attr("src", src);
    $("#pop-up").show();
  });
  $(".prev-btn").on("click", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery_img-wrapper"),
      $prevImage = $wrap.find(".active").prev(".img-one");


    if ($prevImage.length > 0) {
      $wrap.find(".active").removeClass("active");
      $prevImage.addClass("active");
      var $activeSrc = $prevImage.attr("data-src");
      $(".modal--content--inner img").attr("src", $activeSrc);
    }
  });
  $(".next-btn").on("click", function () {
    var $el = $(this),
      $wrap = $el.closest(".gallery_img-wrapper"),
      $prevImage = $wrap.find(".active").next(".img-one");

    if ($prevImage.length > 0) {
      $wrap.find(".active").removeClass("active");
      $prevImage.addClass("active");
      var $activeSrc = $prevImage.attr("data-src");
      $(".modal--content--inner img").attr("src", $activeSrc);
    }
  });

  $(document).on("click", ".modal-close", function (e) {
    e.preventDefault();
    modal("#pop-up", false);
  });


  $(document).on("click", ".img_popup", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el.attr("href");
    modal(target);
  });

  function modal(target, flag = true) {
    if (flag) {
      $(target).show();
      $("body").addClass("modal--opened");
    } else {
      $(target).hide();
      $("body").removeClass("modal--opened");
    }
  }
  //radio btn
  $(".js-input-sw").change(function () {
    var selectedColor = $(this).val();
    $(this).closest(".color_swatches").find(".color_name").text(selectedColor); // Update the color_name text
  });

  //pdp tab

  $(".content").eq(0).show();

  $(".custom-heading .con-head").eq(0).addClass("active-tab");

  $(".custom-heading .con-head").click(function () {
    var $this = $(this);
    var $target = $this.attr("data-target");
    $(".content").hide();
    if (!$this.hasClass("active-tab")) {
      $(".con-head").removeClass("active-tab");
    }
    $this.toggleClass("active-tab");
    $($target).show();
  });

  //adding a class
  $(".shopify-policy__container").addClass("page-width");

  var currentUrl = window.location.href;
  $(".tab-menulist-menu .tab-menulist-child-menu a").each(function () {
    var linkUrl = $(this).attr("href");
    if (currentUrl.includes(linkUrl)) {
      $(this).addClass("active-child");
    }
  });

  //anchor tag on pdp
  $(document).on("click", ".one a", function () {
    var $this = $(this);
    var $target = $this.attr("href");
    $(".content").hide();
    $(".con-head").removeClass("active-tab");
    $('[data-target="' + $target + '"]')
      .closest(".con-head")
      .addClass("active-tab");
    $($target).show();
  });

  try {
    window.onVariantChange = (variant) => {
      setTimeout(function () {
        var value = $('[name="id"]').val(),
          varinat_meta_price = window.variants[value].meta_price;

        $(".product__text .price-start").empty().append(varinat_meta_price);

        calculator(varinat_meta_price);

        $("#width_in, #height_in").on("input", function () {
          calculator(varinat_meta_price);
        });
      }, 1000);
      if (variant) {
        var media_id = variant.featured_media.id,
          slickIndex = $(`.main-img [media_id="${media_id}"]`)
            .eq(0)
            .closest(".slick-slide")
            .attr("data-slick-index");
        $(`.main-img`).slick("slickGoTo", slickIndex);
      }
    };
  } catch (error) {
    console.log(error);
  }


// $(".input_cal").on("change", function () {
//       console.log("Typing in:", this.id, "Value:", this.value);
//     var in_min = parseFloat($(this).attr('min')),
//         c_value = parseFloat($(this).val());
//     if (!isNaN(in_min) && !isNaN(c_value) && c_value < in_min) {
//         $(this).val(in_min);
//     }
//     console.log(in_min,'in_min',c_value);
//   });


  function calculator(varinat_meta_price) {
    var wi = $("#width_in").val(),
      hi = $("#height_in").val();

    if (!isNaN(wi) && !isNaN(hi) && !isNaN(varinat_meta_price)) {
        var result = parseFloat(((wi * hi) / 144).toFixed(2));
        $("#squareContainer").html(
          `<p>Coverage : <span class='res'>${result}</span> Sqft</p>`
        );

        var fwt_wi = wi / 12,
          fwt_hi = hi / 12,
          mon_for_sqft = Math.round(fwt_wi * fwt_hi * varinat_meta_price);
        $(".custom-price")
          .empty()
          .append(
            `Rs. <span class='new-price'>${numberWithCommas(
              mon_for_sqft
            )}</span>.00`
          );
      // if (result < 30) {
      //   // var base_price = parseInt($(".custom-price").attr("data-price"));
 
      //   // $(".custom-price")
      //   //   .empty()
      //   //   .append(
      //   //     `Rs. <span class='new-price'>${numberWithCommas(
      //   //       base_price
      //   //     )}</span>.00`
      //   //   );
      // } else {
      //   $("#squareContainer").html(
      //     `<p>Coverage : <span class='res'>${result}</span> Sqft</p>`
      //   );
      //   var fwt_wi = wi / 12,
      //     fwt_hi = hi / 12,
      //     mon_for_sqft = Math.round(fwt_wi * fwt_hi * varinat_meta_price);
      //   $(".custom-price")
      //     .empty()
      //     .append(
      //       `Rs. <span class='new-price'>${numberWithCommas(
      //         mon_for_sqft
      //       )}</span>.00`
      //     );
      // }

      if (result > 30) {
        $(".api-btn").removeClass("nocart");
      } else {
        $(".api-btn").addClass("nocart");
      }
    } else {
      console.log("Invalid input");
    }
  }
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  var signedUp = getCookie("signedUp");
  // Function to display the popup modal
  function displayPopupModal() {
    $("#pop-ups").css("display", "block");
    $("body").addClass("popup-model-opened");
  }

  // Function to hide the popup modal
  function hidePopupModal() {
    $("#pop-ups").css("display", "none");
    $("body").removeClass("popup-model-opened");
  }

  if (!signedUp) {
    setTimeout(function () {
      displayPopupModal();
    }, 5000);
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Function to get a cookie
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Close popup modal when the close button is clicked
  $(".modal-closed").click(function () {
    hidePopupModal();
  });

  $(".p--info").click(function () {
    hidePopupModal();
  });

  $(window).on("click", function (e) {
    if (e.target.id == "pop-ups") {
      hidePopupModal();
    }
    if (e.target.id == "pop-up") {
      modal("#pop-up", false);
    }
  });
  if ($(".home-popup").find(".text-cpu .copy_text").length > 0) {
    $(".home-popup").addClass("code-here");
    if ($(".home-popup").hasClass("code-here")) {
      setCookie("signedUp", "true", 365);
    }
  }

  // country flag
  $(".img-icon").hide();

  var selectedIsoCode = $("#countrySelect").find(":selected").data("flag");
  $(`[id="${selectedIsoCode}"]`).show();
  $("#countrySelect").change(function () {
    var selectedIsoCode = $(this).find(":selected").data("flag");
    $(".img-icon").hide();
    $(`[id="${selectedIsoCode}"]`).show();

    $("#countrySelect option").removeAttr("selected");
    $(this).find(":selected").attr("selected", "selected");
  });

  // related product

  var related_id = setInterval(function () {
    if ($(".prd--recomm--slide").length) {
      $(".prd--recomm--slide").slick({
        slidesToShow: 4,
        arrows: true,
        infinite: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: true,
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              slidesToShow: 2,
            },
          },
        ],
      });
      clearInterval(related_id);
    }
  }, 100);
  setTimeout(function () {
    clearInterval(related_id);
  }, 10000);

  // gallery
  var itemsToShow = 16,
    itemsIncrement = 4;
  $(".gallery_img-main .image__popup:lt(" + itemsToShow + ")").show();
  $(".load_more").click(function () {
    var visibleItems = $(".gallery_img-main .image__popup:visible").length;
    $(
      ".gallery_img-main .image__popup:lt(" +
        (visibleItems + itemsIncrement) +
        ")"
    ).show();
    if (
      $(".gallery_img-main .image__popup:visible").length ===
      $(".gallery_img-main .image__popup").length
    ) {
      $(".load_more").hide();
    }
  });

  // hover-menu open
  $(".header__inline-menu header-menu details").hover(
    function (e) {
      e.preventDefault();

      $(this).attr("open", true);
      $(this).find("summary").attr("aria-expanded", true);
    },
    function () {
      $(this).removeAttr("open");
      $(this).find("summary").removeAttr("aria-expanded");
    }
  );

  $(document).on("click", ".api-btn", async function () {
    var color_id = $('[action="/cart/add"]').eq(0).find('[name="id"]').val(),
      wi = $("#width_in").val(),
      hi = $("#height_in").val(),
      pc_coverage = parseFloat($("#squareContainer .res").text()),
      title = window.product_title,
      type = "PRICE_CALCULATOR_APP",
      image_src =
        window.variants[color_id].fetured_image.indexOf("https") == -1
          ? "https:" + window.variants[color_id].fetured_image
          : window.variants[color_id].fetured_image,
      variants = [],
      var_title_opt = window.variants[color_id].calc_title,
      description = `<strong>**The product is being created from the custom app, so don't delete it and also don't make it as a draft.**</strong>`,
      var_price = $(".custom-price .new-price").text(),
      var_qty = $(".default-qty .quantity__input").val(),
      var_title = `${wi}" x ${hi}" | ${var_title_opt}`;

    variants.push({
      title: var_title,
      quantity: var_qty,
      price: var_price,
    });

    var send_data = {
      title: title,
      type: type,
      description: description,
      image_src: image_src,
      variants: variants,
    };
    $(this).addClass("loading");
    console.log(send_data);
    try {
      const res = await fetch(
        "https://tetsip-app-303698d9abb6.herokuapp.com/api/getproduct",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify(send_data),
        }
      );
      const json_res = await res.json();

      // add to cart js for custom atc
      setTimeout(function () {
        var formData = {
          id: json_res.data.product.variants[0].id,
          qty: json_res.data.product.variants[0].inventory_quantity,
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          cache: false,
          data: formData,
          dataType: "json",
          success: function (responsse) {
            $("cart-drawer").removeClass('is-empty"');
            $(".drawer__inner-empty").hide();
            $("cart-drawer").load(location.href + " #CartDrawer");
            $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
            window.location.href = "/cart";
          },
          error: function (xhr, ajaxOption, error) {
            console.error("Error adding product to cart:", error);
          },
        });
      }, 800);
    } catch (error) {
      console.log("create product error", error);
    }
  });

  

  var interval_id = setInterval(function () {
    var pdp_hei = $(".related-products .card__inner").height();
    $(".recently-viewed-wrapper img").height(pdp_hei);
  }, 100);
  setTimeout(function () {
    clearInterval(interval_id);
  }, 3000);

  $(".shopify-payment-button button.shopify-payment-button__button").text(
    "order now"
  );



// recently viewed 
  setTimeout(function() {
$('.recently-viewed-wrapper .recently-viewed-grid li.grid__item').each(function ($) {
var compare_price_cm = jQuery(this).find(".card-price .price__compare .price-item").data("productcompareprice");
var regular_price_cm = jQuery(this).find(".card-price .price__last .price-item").data("productprice");
var decreaseValue = compare_price_cm - regular_price_cm;
var result = Math.round(( decreaseValue / compare_price_cm) * 100);
// console.log(result+"%");
if(compare_price_cm > regular_price_cm)
{
$(this).find("span.cstm_discount_pp").text(""+result+"%OFF");
}
});
}, 500);


$('.autoplay').slick({
slidesToShow: 4,
slidesToScroll: 1,
arrows: true,
autoplay: true,
autoplaySpeed: 2000,
prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
responsive: [
{
breakpoint: 768,
settings: {
arrows: true,
centerPadding: '40px',
slidesToShow: 2
}
},
{
breakpoint: 480,
settings: {
arrows: true,
centerPadding: '40px',
slidesToShow: 2
}
}
]
});
  
});









// start custom js
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(
    "body.template--collection .metafield-rich_text_field"
  );

  if (!container) return;

  const firstH2 = container.querySelector("h2");
  const firstP = container.querySelector("h2 + p");

  if (!firstH2 || !firstP) return;

  // Create wrapper
  const wrapper = document.createElement("div");
  wrapper.className = "wrapped-content";
  wrapper.style.display = "none"; // hidden by default

  // Move all content except first h2 and first p into wrapper
  Array.from(container.children).forEach(child => {
    if (child !== firstH2 && child !== firstP) {
      wrapper.appendChild(child);
    }
  });

  // Insert wrapper after first paragraph
  firstP.after(wrapper);

  // Toggle on click
  firstP.style.cursor = "pointer";

  firstP.addEventListener("click", function () {
    const isHidden = wrapper.style.display === "none";

    wrapper.style.display = isHidden ? "block" : "none";
    firstP.classList.toggle("is-expanded", isHidden);
  });
});
// end custom js

$(document).on('click', '.buy_sample-prod', function () {

    var ID = $(this).closest('.two-btn').find('#sample_product').val();
     var value = $('[name="id"]').val(),
       varinat_title = window.variants[value].calc_title;

    // GET CART
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function (cart) {

            var alreadyInCart = cart.items.some(function (item) {
                return item.id == ID;
            });

            // if (alreadyInCart) {
            //     // alert('Sample already in cart');
            //     $('.error_sample').html('Sample already in cart');
            //     // window.location.href = '/cart';
            //     return;
            // }

            // ADD TO CART
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    id: ID,
                    quantity: 1,
                    'properties[For Sample]': varinat_title,
                },
                success: function (res) {
                    console.log('Added:', res);
                    window.location.href = '/cart';
                },
                error: function (err) {
                    console.error('Add error:', err.responseText);
                }
            });
        },
        error: function (err) {
            console.error('Cart fetch error:', err);
        }
    });

});



// Open popup
$(document).on('click', '.nav-delete-btn', function (e) {
    e.preventDefault();

    $('.del-popup-wrapper').addClass('active');
    $('body').addClass('active-popup');
});

// Close button
$(document).on('click', '.del-popup-wrapper .close', function () {
    $('.del-popup-wrapper').removeClass('active');
    $('body').removeClass('active-popup');
});

// Close on overlay click
$(document).on('click', '.del-popup-wrapper', function (e) {
    if ($(e.target).hasClass('del-popup-wrapper')) {
        $('.del-popup-wrapper').removeClass('active');
        $('body').removeClass('active-popup');
    }
});
